import { render, staticRenderFns } from "./MailSelector.vue?vue&type=template&id=370f107f"
import script from "./MailSelector.vue?vue&type=script&lang=js"
export * from "./MailSelector.vue?vue&type=script&lang=js"
import style0 from "./MailSelector.vue?vue&type=style&index=0&id=370f107f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports